/**
 * Geldbetraege sind IMMER ganze Cents (number, integer). Keine Floats, keine
 * Strings mit Komma in der Fachlogik. Formatierung nur an der Oberflaeche.
 */
export type Cents = number;

export function istCents(n: unknown): n is Cents {
  return typeof n === 'number' && Number.isInteger(n);
}

/** "12.50" | "12,50" | 12.5 → 1250. Wirft bei unbrauchbarer Eingabe. */
export function centsAus(wert: string | number): Cents {
  const text = String(wert).trim().replace(',', '.');
  if (!/^-?\d+(\.\d{1,2})?$/.test(text)) throw new Error(`Kein Geldbetrag: ${JSON.stringify(wert)}`);
  const negativ = text.startsWith('-');
  const [ganz, nach = ''] = text.replace('-', '').split('.');
  const cents = Number(ganz) * 100 + Number((nach + '00').slice(0, 2));
  return negativ ? -cents : cents;
}

/** 1250 → "12,50" (deutsche Schreibweise, ohne Waehrung, ohne Tausenderpunkt). */
export function centsAlsText(cents: Cents): string {
  const vz = cents < 0 ? '-' : '';
  const b = Math.abs(cents);
  return `${vz}${Math.floor(b / 100)},${String(b % 100).padStart(2, '0')}`;
}

/** 1250 → "12,50 €" */
export function eur(cents: Cents): string {
  return `${centsAlsText(cents)} €`;
}

/** Kaufmaennisch runden (halbe Cents nach oben, auch negativ weg von Null). */
export function rundeCents(wert: number): Cents {
  return Math.sign(wert) * Math.round(Math.abs(wert));
}
